import BaseQuestionModel from '../BaseQuestionModel'
import { IQuestionModelConstructor, QuestionType } from '../types'
import { ReorderQuestionModelTypes, IReorderQuestionModelState, IReorderResponseValidation } from './types'

const ReorderQuestionModel: IQuestionModelConstructor<ReorderQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<ReorderQuestionModelTypes, IReorderQuestionModelState>({
    questionType: QuestionType.REORDER,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}

function submitResponse({ response, questionSchema, action }: IReorderQuestionModelState) {
  return response
    .filter(answerId => {
      const answer = questionSchema.answers.find(answer => answer.id === answerId)
      return answer && false !== action?.data?.rules?.show[answer.id]
    })
    .map(answerId => {
      return { id: answerId }
    })
}

function initState(state: IReorderQuestionModelState): IReorderQuestionModelState {
  state.response = []
  return state
}

function validateResponse({ response, questionSchema }: IReorderQuestionModelState): IReorderResponseValidation {
  if (questionSchema.answers.filter(answer => !answer.hidden).length <= 1)
    return {
      valid: true
    }

  return {
    valid: response.length > 0
  }
}

export default ReorderQuestionModel
